module.exports = __webpack_public_path__ + "img/thumbnail.e4b3e4f7.jpg";